import React from 'react';
import { DialogState } from './types';

export const DialogContext = React.createContext<DialogState | null>(null);
